import {handleLogout} from "components/utils";
import React, {forwardRef, useEffect, useRef, useState} from 'react';
import {Button, Col, Form, Row, Table} from "react-bootstrap";
import axios from "axios";
import Editor from "react-simple-wysiwyg";
import {RichEditor} from "../ipd/consentForms/RichEditor";
import {array} from "prop-types";
import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions, TableBody,
    TableColumnType,
    TableHeader
} from "react-bs-datatable";

export const IpdUploadView = forwardRef((props: { caseDetails: any, fetch: any }, ref) => {

    const [uploads, setUploads] = useState<Array<any>>([]);
    const [name, setName] = useState<String>();
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [file, setFile] = useState<any>();
    let componentRef = useRef(null);


    useEffect(() => {
        if (props.caseDetails) {
            setUploads(props.caseDetails.uploads ? JSON.parse(props.caseDetails.uploads) : [])
        }
    }, [props.caseDetails])

    const handleChange = event => {
        setErrorMessage(null)
        if (event.target.files && event.target.files[0]) {
            const selectedFile = event.target.files[0];
            if (selectedFile.size > 6000000) {
                setErrorMessage("File size should be less than 5 MB")
            } else {
                setFile(selectedFile);
            }
        }
    };


    const uploadFile = async () => {

        let key = props.caseDetails.caseId + "_" + file.name
        let {data} = await axios.post("/api/s3/upload", {
            name: key,
            type: file.type,
        });

        console.log(data);

        const url = data.url;
        let {data: newData} = await axios.put(url, file, {
            headers: {
                "Content-type": file.type,
                "Access-Control-Allow-Origin": "*",
            },
        });

        console.log(newData);

        return key
    };


    const handleUpdate = (e) => {
        e.preventDefault();
        setErrorMessage(null)
        setLoading(true)
        if (!file) {
            setErrorMessage("Please select a file to upload")
        }
        uploadFile()
            .then(resp => {
                console.log(resp)
                axios.post('/api/backend/ipd/case/update/uploads/' + props.caseDetails.id, {
                    upload: JSON.stringify([...uploads,{name: name, key: resp}])
                })
                    .then(resp => {
                        console.log(resp.data)
                        props.fetch()
                    })
                    .catch(err => {
                        setErrorMessage("Error while creating the record. Please verify the record Id")
                        console.error(err);
                        if (err.response && err.response!.status && err.response!.status === 403) {
                            handleLogout()
                        }
                        ;
                    }).finally(() => setLoading(false));
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
                ;
                setErrorMessage("Error while uploading the file")
            }).finally(() => setLoading(false));

    }

    const ITEMS_HEADERS: TableColumnType<any>[] = [
        {
            prop: "name",
            title: "Name",
            isFilterable: true,
            isSortable: true
        },
        {
            prop: "button",
            cell: (row) => (
                <><a target="_blank" rel="noreferrer"
                     href={"/api/s3/download/?file=" + row.key}
                     className="text-success font-weight-bold"> &#x2193;</a></>
            )
        }
    ];

    function getItemsTable() {
        return <div className="overflow-scroll"><DatatableWrapper
            body={uploads}
            headers={ITEMS_HEADERS}
            paginationOptionsProps={{
                initialState: {
                    rowsPerPage: 30,
                    options: [30, 50, 100]
                }
            }}
        >
            <Row className="">
                <Col
                    xs={12}
                    lg={4}
                    className="d-flex flex-col justify-content-end align-items-end"
                >
                </Col>
                <Col
                    xs={12}
                    sm={6}
                    lg={4}
                    className="d-flex flex-col justify-content-lg-center align-items-center justify-content-sm-start mb-2 mb-sm-0"
                >
                </Col>
                <Col
                    xs={12}
                    sm={6}
                    lg={4}
                    className="d-flex flex-col justify-content-end align-items-end"
                >
                </Col>
            </Row>
            <Table>
                <TableHeader/>
                <TableBody/>
            </Table>
            <Row className="mt-4">
                <Col
                    xs={12}
                    sm={12}
                    lg={12}
                    className="d-flex flex-col justify-content-end align-items-end"
                >
                </Col>
            </Row>
        </DatatableWrapper>
        </div>;
    }

    return (
        <>
            <>
                <div className="row">
                    <div className="col col-12">
                        <h5 className="text-primary">Uploads</h5>
                        {getItemsTable()}
                    </div>
                    <div className="col col-12">
                        <div className="my-2 d-flex gap-2">
                            <label className="align-self-center text-info text-nowrap">File Name:</label>
                            <input type="text"
                                   className="form-control form-control-sm"
                                   onChange={e => setName(e.target.value)}/>
                        </div>
                    </div>
                    <div className="col col-12">
                        <div className="my-2 d-flex gap-2">
                            <label className="align-self-center text-info">File:</label>
                            <input type="file"
                                   ref={componentRef}
                                   className="form-control form-select-sm"
                                   accept=".doc,.docx,.HEIC,.HEIC,.HEVC,image/*,application/pdf"
                                   onChange={handleChange}/>
                        </div>
                    </div>
                </div>
                <div className="my-4">
                    <button className="btn btn-info text-white btn-sm"
                            onClick={e => handleUpdate(e)}>
                        {loading &&
                            <div className="text-center">
                                <div className="spinner-border" role="status">
                                </div>
                            </div>
                        }
                        {!loading && <>Add Report</>}
                    </button>
                    {errorMessage &&
                        <div className="text-danger fs-6">*{errorMessage}</div>
                    }
                </div>
            </>

        </>

    );
});

IpdUploadView.displayName = "IpdUploadView";